export class CustomerInfo {
  public firstName: string;
  public lastName: string;
  public email: string;
  public phone: string;
}
